import * as actionTypes from "./constants";
import * as Service from "./services";

const getTaskManagerList = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_GENERAL_TASK_MANAGER_LIST_REQUEST });
            const res = await Service.getTaskManagerList(params);
            if (res && res.status === 200) {
                const propertiesList = res.data;
                dispatch({
                    type: actionTypes.GET_GENERAL_TASK_MANAGER_LIST_SUCCESS,
                    response: propertiesList
                });
            } else {
                dispatch({
                    type: actionTypes.GET_GENERAL_TASK_MANAGER_LIST_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_GENERAL_TASK_MANAGER_LIST_FAILURE,
                error: e.response && e?.response?.data
            });
        }
    };
};

const getListForCommonFilter = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_GENERAL_TASK_MANAGER_TABLE_FILTER_REQUEST });
            const res = await Service.getListForCommonFilter(params);
            if (res && res.status === 200) {
                const list = res.data?.detail || res.data?.list || res.data?.data || [];
                dispatch({
                    type: actionTypes.GET_GENERAL_TASK_MANAGER_TABLE_FILTER_SUCCESS,
                    response: res.data
                });
                return { list, count: res.data?.count ?? list.length };
            }
            dispatch({
                type: actionTypes.GET_GENERAL_TASK_MANAGER_TABLE_FILTER_FAILURE,
                error: res.response && res.response.data
            });
            return { list: [] };
        } catch (e) {
            dispatch({
                type: actionTypes.GET_GENERAL_TASK_MANAGER_TABLE_FILTER_FAILURE,
                error: e.response && e?.response?.data
            });
            return { list: [] };
        }
    };
};

const deleteTaskManagerById = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_GENERAL_TASK_MANAGER_BY_ID_REQUEST });
            const res = await Service.deleteTaskManagerById(id);
            if (res && (res.status === 200 || res.status === 204)) {
                const deleteTaskManagerById = res.data;
                dispatch({
                    type: actionTypes.DELETE_GENERAL_TASK_MANAGER_BY_ID_SUCCESS,
                    response: deleteTaskManagerById
                });
            } else {
                dispatch({
                    type: actionTypes.DELETE_GENERAL_TASK_MANAGER_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_GENERAL_TASK_MANAGER_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const cancelTaskManagerById = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.CANCEL_GENERAL_TASK_MANAGER_BY_ID_REQUEST });
            const res = await Service.cancelTaskManagerById(id);
            if (res && (res.status === 200 || res.status === 204)) {
                const cancelTaskManagerById = res.data;
                dispatch({
                    type: actionTypes.CANCEL_GENERAL_TASK_MANAGER_BY_ID_SUCCESS,
                    response: cancelTaskManagerById
                });
            } else {
                dispatch({
                    type: actionTypes.CANCEL_GENERAL_TASK_MANAGER_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.CANCEL_GENERAL_TASK_MANAGER_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const updateTaskManagerEntityParams = entityParams => {
    return async dispatch => {
        try {
            if (entityParams) {
                dispatch({
                    type: actionTypes.UPDATE_TASK_MANAGER_ENTITY_PARAMS_SUCCESS,
                    response: entityParams
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_TASK_MANAGER_ENTITY_PARAMS_FAILURE,
                error: entityParams
            });
        }
    };
};
export default {
    getTaskManagerList,
    getListForCommonFilter,
    deleteTaskManagerById,
    cancelTaskManagerById,
    updateTaskManagerEntityParams
};
